import { render, staticRenderFns } from "./Spatial_Roaming.vue?vue&type=template&id=2dc0bf25&scoped=true&"
import script from "./Spatial_Roaming.vue?vue&type=script&lang=js&"
export * from "./Spatial_Roaming.vue?vue&type=script&lang=js&"
import style0 from "./Spatial_Roaming.vue?vue&type=style&index=0&id=2dc0bf25&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc0bf25",
  null
  
)

export default component.exports